export default "__VITE_ASSET__B2k5xi8g__"